import { replace } from 'react-router-redux'
import createReducer from '../../../util/createReducer';
import * as http from '../../../util/http';
import {HANDLE_OPEN} from '../../../uis/tip/reduces'
// ------------------------------------
// Constants
// ------------------------------------
export const RECEIVE_USER_INFO = 'RECEIVE_USER_INFO';

export const GET_VERIFICATION = 'GET_VERIFICATION';

export const GET_RANDOM_CODE = `GET_RANDOM_CODE`

export const SIGN_OUT_USER_INFO = 'SIGN_OUT_USER_INFO';

export const SESSION_USER_INFO = 'SESSION_USER_INFO';

export const storage = window.localStorage;
// ------------------------------------
// Actions
// ------------------------------------

export function signUpFn(body) {
    return (dispatch, getState) => {
        const sessionSignUpId = getState().auth.user.sessionSignUpId;
        return http.post(`/user/register?sessionSignUpId=${sessionSignUpId}`, body)
            .then(data => {
                dispatch({
                    type: RECEIVE_USER_INFO,
                    data
                })
                storage.setItem(SESSION_USER_INFO, JSON.stringify(getState().auth.user));
                if (SESSION_USER_INFO) {
                    dispatch({type: HANDLE_OPEN,variant: 'success',message: '恭喜您，注册成功，即将前往登录',time: 1500})
                }
                dispatch(replace('/sign/sign-in'))
            })
    };
}
export function signInFn(body) {
    return (dispatch, getState) => {
        return http.get('http://cn2.caihongjianzhan.com/api/admin/md/public/mmtgabx4294/ip-search')
            .then((data) => {
                if (!data.isFind) {
                    dispatch({type: HANDLE_OPEN,variant: 'error',message: "您的IP不在白名单内，请联系管理员"});
                    return Promise.reject();
                }
                return Promise.resolve();
            })
            .then(() => {
                return http.post('/user/login', body)
            })
            .then(data => {
                console.info(data)
                const permissionMap = {};
                data.data.user.roles.forEach(role=>{
                    role.rolePermissions.forEach(permission=>{
                        permissionMap[permission.permissionName] = true
                    })
                })
                dispatch({
                    type: RECEIVE_USER_INFO,
                    data: {...data.data, permissionMap}
                });
                storage.setItem(SESSION_USER_INFO, JSON.stringify(getState().auth.user));
                dispatch(replace(getState().auth.user.redirectUrl));
            })
    };
}
export function signOutFn() {
    return (dispatch) => {
        storage.removeItem(SESSION_USER_INFO)
        dispatch({
            type: SIGN_OUT_USER_INFO
        });
        dispatch(replace('/sign/sign-in'))
    };
}
export function resetFn(body) {
    return (dispatch,getState) => {
        const sessionSignUpId = getState().auth.user.sessionSignUpId;
        return http.post(`/user/change-password?sessionSignUpId=${sessionSignUpId}`, body)
            .then(() => {
                dispatch({
                    type: SIGN_OUT_USER_INFO
                });
                storage.removeItem(SESSION_USER_INFO);
                dispatch({type: HANDLE_OPEN,variant: 'success',message: '密码已重置，请重新登录',time: 1500})
                dispatch(replace('/sign/sign-in'));
            })
    };
}
export function getVerification(phone,type) {
    return (dispatch,getState) => {
        return http.get(`/user/send-code?phone=${phone}&type=${type}`)
            .then(data => {
                dispatch({ 
                    type: GET_VERIFICATION,
                    data:data.data
                }); 
            })
    }
}

export function getRandomCode() {
    return (dispatch,getState) => {
        return http.get(`/user/check-code`) 
            .then((data) => {
                dispatch({
                    type: GET_RANDOM_CODE,
                    data: data.data.checkCode
                })
            })
    }  
}
// ------------------------------------
// Reducer
// ------------------------------------
const defaultState = {
    redirectUrl: '/',
    checkCode: ''
};
const initialState = JSON.parse(storage.getItem(SESSION_USER_INFO)) || {...defaultState};
export default createReducer(initialState, {
    [RECEIVE_USER_INFO]: (state, {data}) => {
        return {...state, ...data,authenticated: true}
    },
    [SIGN_OUT_USER_INFO]: () => {
        return {...defaultState,authenticated: false}
    },
    [GET_VERIFICATION]: (state, {data}) => {
        return {...state,sessionSignUpId: data.sessionSignUpId}
    },
    [GET_RANDOM_CODE]:(state,{data}) => {
        return {...state,checkCode: data}
    }
})


// WEBPACK FOOTER //
// ./src/pages/sign/reducers/user.js